// src/htmlFormatterUtils.js
export const formatHtml = (html) => {
    try {
        // Void elements never have a closing tag
        const VOID = new Set(['area','base','br','col','embed','hr','img','input','link','meta','param','source','track','wbr']);
        // Raw-text elements — preserve their inner content exactly
        const RAW = new Set(['pre','script','style','textarea']);

        let result = '';
        let indent = 0;
        let rawTag = ''; // set when inside a RAW element

        // Tokenise into tags and text nodes
        const tokenRegex = /(<!--[\s\S]*?-->|<\/?[a-zA-Z][^>]*?>|[^<]+)/g;
        let match;

        while ((match = tokenRegex.exec(html)) !== null) {
            const token = match[0];

            // Inside a raw element — output verbatim until its closing tag
            if (rawTag) {
                result += token;
                if (token.toLowerCase() === `</${rawTag}>`) {
                    rawTag = '';
                    result += '\n';
                }
                continue;
            }

            if (token.startsWith('<!--')) {
                result += '  '.repeat(indent) + token.trim() + '\n';
                continue;
            }

            if (token.startsWith('</')) {
                const tagName = (token.match(/^<\/([a-zA-Z][a-zA-Z0-9-]*)/) || [])[1]?.toLowerCase() || '';
                if (!VOID.has(tagName)) indent = Math.max(indent - 1, 0);
                result += '  '.repeat(indent) + token.trim() + '\n';
                continue;
            }

            if (token.startsWith('<')) {
                const tagName = (token.match(/^<([a-zA-Z][a-zA-Z0-9-]*)/) || [])[1]?.toLowerCase() || '';
                const isSelfClosing = token.endsWith('/>') || VOID.has(tagName);
                result += '  '.repeat(indent) + token.trim() + '\n';
                if (!isSelfClosing) {
                    if (RAW.has(tagName)) {
                        rawTag = tagName; // preserve content of next tokens verbatim
                    } else {
                        indent++;
                    }
                }
                continue;
            }

            // Plain text node
            const text = token.trim();
            if (text) result += '  '.repeat(indent) + text + '\n';
        }

        return result.trim();
    } catch (error) {
        return "Invalid HTML";
    }
};
  